import { getDomain } from '@/utils/getDomain';
import { getUrl } from '@/utils/getUrl';
import { isClient } from '@/utils/isClient';
import { getOcelotConfig } from 'lib/configs/ocelot';
import { isProduction } from 'lib/labrador/utils';

const shouldUseV2Auth = getOcelotConfig('features.login.v2.enabled');

export const getAipAccountUrl = () => {
  return process.env.AIP_ACCOUNT_URL;
};

export const getUserAuthUrl = () => {
  if (shouldUseV2Auth) {
    return isClient() ? window.location.origin : getDomain(false);
  }
  return isProduction ? 'https://login.allermedia.se' : 'https://login-stage.allermedia.se';
};

const getAuthUrl = (path = '', params?: Record<string, string>) => {
  const url = getUrl(path, getUserAuthUrl());

  if (!url) {
    throw Error('Unable to get user auth url');
  }

  url.search = new URLSearchParams(params ?? { return: getDomain(false) }).toString();

  return url.href;
};

const getBrandName = () => getOcelotConfig('features.login.v1.brandName');

export const getUserLogInUrl = (params?: Record<string, string>) => {
  return shouldUseV2Auth ? getAuthUrl('/api/auth/login', params) : getAuthUrl('', params);
};

export const getUserSignUpUrl = (params?: Record<string, string>) => {
  return shouldUseV2Auth ? getAuthUrl('/api/auth/login', params) : getAuthUrl('/nytt-konto', params);
};

export const getUserPageUrl = (params?: Record<string, string>) => {
  if (shouldUseV2Auth) {
    const url = getUrl('/settings', getAipAccountUrl());
    return url?.href;
  }
  return getAuthUrl('/mina-sidor', params);
};

export const getUserLogOutUrl = (params?: Record<string, string>) => {
  return shouldUseV2Auth ? getAuthUrl('/api/auth/logout', params) : getAuthUrl(`/logout/${getBrandName()}`, params);
};

export const getUserPasswordlessUrl = (params?: Record<string, string>) => {
  if (shouldUseV2Auth) {
    throw new Error('getUserPasswordlessUrl is not supported in v2 auth system');
  }
  return getAuthUrl('/account/passwordless', params);
};

export const getPasswordResetPageUrl = (params?: Record<string, string>) => {
  if (shouldUseV2Auth) {
    const url = getUrl('/recovery', getAipAccountUrl());
    return url?.href;
  }
  return getAuthUrl('/aterstall-losenord', params);
};
